






























import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import { FieldTooltip } from "wings-ui-components";

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

@Component({
  components: {FieldTooltip, ECharts}
})
export default class PushPieChartCard extends Vue {
  @Prop() readonly total: any | undefined;
  @Prop() readonly statusColors: any | undefined;
  @Prop() readonly optionallyGroupBy!: string;

  private key = 0;
  private actualTransferred: number = JSON.parse(localStorage.getItem('pushActualTransferred') || '1');

  get chartData (){
    return this.actualTransferred ? this.pushTotalChartData : this.totalChartData
  }

  get pushTotalChartData() {
    if (!this.total) return [];
    const data = [
      {
        name: this.$t('delivered'),
        value: this.total.delivered + this.total.read,
        itemStyle: { color: this.statusColors.delivered },
        tooltip: this.$t('delivered_chart_tooltip')
      },
      {
        name: this.$t('transmitted'),
        value: this.total.transmitted,
        itemStyle: { color: this.statusColors.transmitted },
        tooltip: this.$t('transmitted_chart_tooltip')
      }
    ]

    return data.sort((a, b) => {
      if (a.value > b.value) {return -1;}
      if (a.value < b.value) {return 1;}
      return 0;
    });
  }

  get totalChartData() {
    let data: any[] = [];
    if (!this.total) return data;
    const $t = this.$t.bind(this);

    for (let index in this.total) {
      if (['date', 'duration', 'provider_price', 'partner_price', 'total', 'totalRow'].includes(index)) continue;
      if (this.optionallyGroupBy == index) continue
      if (index.endsWith('_parts')) continue;
      let item = this.total[index];
      let color = index in this.statusColors ? this.statusColors[index] : ''

      data.push({
        name: $t(index),
        value: item,
        itemStyle: {
          color: color,
        },
      });
    }

    data.sort((a, b) => {
      if (a.value > b.value) {return -1;}
      if (a.value < b.value) {return 1;}
      return 0;
    });
    return data;
  }

  get options() {return {
    tooltip: {
      trigger: 'item',
      formatter: (item: any) => item.tooltip
    },
    series: [
      {
        name: 'Chart',
        type: 'pie',
        radius: ['0%', '90%'],
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: 'inner',
          formatter: function(item: any) {
            const percent = item.percent || 0;
            return percent.toFixed() + '%';
          },
        },
        data: this.chartData.filter(e=>e.value)
      }
    ],
    animationDuration: 1000
  }
  };

  @Watch('actualTransferred', { deep: true })
  onDataChanged() {
    localStorage.setItem('pushActualTransferred', JSON.stringify(this.actualTransferred));
    this.key++;
  }
}
